import { Decimal } from "classes/DecimalClasses";

import {
  updateLot,
  updateSerials,
  getUomConversion,
  getUomConversionRatio,
} from "services/utility/afterTouchLine";
import { isNonZeroDecimalOrMoney } from "services/utility/misc";

// when this field (the key) changes, we should run the (value) list of
// updater functions
const UPDATERS = {
  uom: [updateOnHand, convertUsedPer, convertQuantity],
  quantity: [updateUsedPer],
  usedPer: [updateQuantity],
  bin: [updateLot, updateSerials],
};

// this should be called each time an item receipt line item is modified;
// it returns a new copy of the line, with any necessary changes made
export function afterTouchInputLine(line, changedField, output) {
  if (!UPDATERS[changedField]) {
    return line;
  }
  let newLine = { ...line };
  UPDATERS[changedField].forEach((updater) => {
    newLine = updater(newLine, output);
  });
  return newLine;
}

function updateOnHand(line) {
  const {
    uom,
    relatedRecords: { item },
    itemDetails,
  } = line;

  // calculate the conversion using the item details UOM data
  const conversion = getUomConversion(itemDetails, uom);
  const onhand = item.id ? item.onhand.div(conversion) : new Decimal(0);
  return { ...line, onhand };
}

function updateUsedPer(line, output) {
  const { quantity, uom } = line;
  const lineConversion = uom?.conversion || new Decimal(1);
  const usedPer = isNonZeroDecimalOrMoney(output.quantity)
    ? quantity.div(output.quantity).times(lineConversion)
    : new Decimal(0);
  return { ...line, usedPer };
}

function updateQuantity(line, output) {
  const { usedPer, uom } = line;
  const lineConversion = uom?.conversion || new Decimal(1);
  const quantity = usedPer.times(output.quantity).div(lineConversion);
  return { ...line, quantity };
}

function convertQuantity(line) {
  const { quantity, uom, oldUom, itemDetails } = line;
  const conversionRatio = getUomConversionRatio(itemDetails, uom, oldUom);
  const newQuantity = quantity.times(conversionRatio);
  return { ...line, quantity: newQuantity };
}

function convertUsedPer(line) {
  const { usedPer, uom, oldUom, itemDetails } = line;
  const conversionRatio = getUomConversionRatio(itemDetails, uom, oldUom);
  const newUsedPer = usedPer.times(conversionRatio);
  return { ...line, usedPer: newUsedPer };
}

export const INPUT_ZERO_TOTALS = { quantity: new Decimal(0) };

export function updateInputTotals(lines, setTotals) {
  if (!lines || lines.length === 0) {
    setTotals(INPUT_ZERO_TOTALS);
    return;
  }

  const quantity = lines.reduce((total, line) => {
    return total.plus(line.quantity);
  }, new Decimal(0));

  setTotals({ quantity });
}
